import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import AmbientStarfield from "../components/rewards/shared/AmbientStarfield";
import SacredEmblem from "../components/rewards/shared/SacredEmblem";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#050510] relative flex items-center justify-center px-4 py-10">
      <AmbientStarfield />
      <div className="relative z-10 max-w-md w-full rounded-2xl border border-divine-gold/25 bg-black/50 backdrop-blur-xl p-8 text-center" data-testid="payment-cancel-card">
        <div className="flex justify-center mb-4">
          <SacredEmblem size={56} className="opacity-70" />
        </div>
        <div className="flex justify-center mb-4">
          <XCircle className="w-14 h-14 text-white/40" />
        </div>
        <h1 className="text-xl font-semibold text-divine-gold mb-2">Checkout cancelled</h1>
        <p className="text-white/70 text-sm mb-6">
          No charge was made. Your account is unchanged — come back any time.
        </p>
        <Button
          onClick={() => navigate("/dashboard")}
          className="bg-divine-gold hover:bg-divine-gold/90 text-black font-medium w-full"
          data-testid="payment-cancel-back-btn"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Return to Dashboard
        </Button>
      </div>
    </div>
  );
}
